export const STRATEGY_MANUAL_CALL = {
    "wrongNumber": function (json) {
        if (typeof wrongNumber === 'function') {
            wrongNumber(json.data);
        }
    },
    "onDialResult": function (json) {
        if (typeof onDialResult === 'function') {
            onDialResult(json.data);
        }
    },
    "numberOnDoNotCallList": function () {
        if (typeof numberOnDoNotCallList === 'function') {
            numberOnDoNotCallList();
        }
    },
    "timeZoneNumber": function (json) {
        if (typeof timeZoneNumber === 'function') {
            timeZoneNumber(json.data.number);
        }
    },
    "onError": function (json) {
        if (typeof onErrorManualCall === 'function') {
            onErrorManualCall(json.data);
        }
    },
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyManualCall.js